import { DatePipe, DateTimePipe } from '../../tunnelsante-i18n/pipes/date.pipe';
import { AgencyStatusIndicatorComponent } from '../components/agency-status-indicator/agency-status-indicator.component';
import { AlertActionsComponent } from '../components/alert/alert-actions/alert-actions.component';
import { AlertComponent } from '../components/alert/alert.component';
import { AsyncContentComponent } from '../components/async-content/async-content.component';
import { AvenantRequestAlertComponent } from '../components/avenant-request-alert/avenant-request-alert.component';
import { BanjRejectReasonIndicatorComponent } from '../components/bank-reject-reason-indicator/bank-reject-reason-indicator.component';
import { BarLoaderComponent } from '../components/bar-loader/bar-loader.component';
import { CarViewerComponent } from '../components/car-viewer/car-viewer.component';
import { ComplementAlertComponent } from '../components/complement-alert/complement-alert.component';
import { ContactUsFabComponent } from '../components/contact-us-fab/contact-us-fab.component';
import { ContentLoaderComponent } from '../components/content-loader/content-loader.component';
import { CountdownComponent } from '../components/countdown/countdown.component';
import { DocumentStatusIconComponent } from '../components/document-status-icon/document-status-icon.component';
import { EnumComponent } from '../components/enum/enum.component';
import { ErrorViewerComponent } from '../components/error-viewer/error-viewer.component';
import { FragmentStatusIconComponent } from '../components/fragment-status-icon/fragment-status-icon.component';
import { HealthHelpDialogComponent } from '../components/health-help-dialog/health-help-dialog.component';
import { ImmatriculationComponent } from '../components/immatriculation/immatriculation.component';
import { InfoBoxComponent } from '../components/info-box/info-box.component';
import { InfoTooltipComponent } from '../components/info-tooltip/info-tooltip.component';
import { MatTableContainerActionsComponent } from '../components/mat-table-container/mat-table-container-actions/mat-table-container-actions.component';
import { MatTableContainerFilterComponent } from '../components/mat-table-container/mat-table-container-filter/mat-table-container-filter.component';
import { MatTableContainerComponent } from '../components/mat-table-container/mat-table-container.component';
import { PaymentOrderAlertComponent } from '../components/payment-order-alert/payment-order-alert.component';
import { PaymentTransactionAlertComponent } from '../components/payment-transaction-alert/payment-transaction-alert.component';
import { PersonFullNameComponent } from '../components/person-fullname/person-fullname.component';
import { PolicyStatusIconComponent } from '../components/policy-status-icon/policy-status-icon.component';
import { PricingComponent } from '../components/pricing/pricing.component';
import { ProductRightIndicatorComponent } from '../components/product-right-indicator/product-right-indicator.component';
import { ProgressBarComponent } from '../components/progress-bar/progress-bar.component';
import { ReceiptStateIndicatorComponent } from '../components/receipt-state-indicator/receipt-state-indicator.component';
import { RenewalAlertComponent } from '../components/renewal-alert/renewal-alert.component';
import { RequestStateIndicatorComponent } from '../components/request-state-indicator/request-state-indicator.component';
import { RequestTypeIndicatorComponent } from '../components/request-type-indicator/request-type-indicator.component';
import { SignatureOrderAlertComponent } from '../components/signature-order-alert/signature-order-alert.component';
import { SimpleDocumentationComponent } from '../components/simple-documentation/simple-documentation.component';
import { SquareLoaderComponent } from '../components/square-loader/square-loader.component';
import { StarRatingComponent } from '../components/star-rating/star-rating.component';
import { StatusIndicatorComponent } from '../components/status-indicator/status-indicator.component';
import { StepperComponent } from '../components/stepper/stepper.component';
import { Stepper2Component } from '../components/stepper2/stepper2.component';
import { SvaNumberComponent } from '../components/sva-number/sva-number.component';
import { TerminationRequestAlertComponent } from '../components/termination-request-alert/termination-request-alert.component';
import { UniversBesoinIconComponent } from '../components/univers-besoin-icon/univers-besoin-icon.component';
import { UniversBesoinQuestionTableComponent } from '../components/univers-besoin-question-table/univers-besoin-question-table.component';
import { UniversBesoinTableComponent } from '../components/univers-besoin-table/univers-besoin-table.component';
import { WarrantyListComponent } from '../components/warranty-list/warranty-list.component';
import { WorkInProgressComponent } from '../components/work-in-progress/work-in-progress.component';
import {
  AsyncContentErrorDirective,
  EXPANDABLE_DIRECTIVES,
} from '../directives';
import { SetFocusDirective } from '../directives/set-focus.directive';
import { ShowTransitionDirective } from '../directives/show-transition.directive';
import { TunnelSanteTranslateDirective } from '../directives/translate.directive';
import { AddressPipe } from '../pipes/address.pipe';
import { ErrorPipe } from '../pipes/error.pipe';
import { FullNamePipe } from '../pipes/fullname.pipe';
import { RequestColorPipe } from '../pipes/request-color.pipe';
import { ToFixedPipe } from '../pipes/to-fixed.pipe';
import { UniversBesoinMetricPipe } from '../pipes/univers-besoin-metric.pipe';

export const wzUiExportedComponents = [
  BarLoaderComponent,
  SquareLoaderComponent,
  ProgressBarComponent,
  MatTableContainerComponent,
  MatTableContainerFilterComponent,
  WorkInProgressComponent,
  StatusIndicatorComponent,
  InfoBoxComponent,
  ContentLoaderComponent,
  ContactUsFabComponent,
  SvaNumberComponent,
  StepperComponent,
  Stepper2Component,
  PricingComponent,
  InfoTooltipComponent,
  PersonFullNameComponent,
  CarViewerComponent,
  PolicyStatusIconComponent,
  EnumComponent,
  DocumentStatusIconComponent,
  FragmentStatusIconComponent,
  ReceiptStateIndicatorComponent,
  BanjRejectReasonIndicatorComponent,
  AgencyStatusIndicatorComponent,
  MatTableContainerActionsComponent,
  WarrantyListComponent,
  ErrorViewerComponent,
  AlertComponent,
  AlertActionsComponent,
  AsyncContentComponent,
  TerminationRequestAlertComponent,
  RequestStateIndicatorComponent,
  PaymentTransactionAlertComponent,
  AvenantRequestAlertComponent,
  RequestTypeIndicatorComponent,
  ComplementAlertComponent,
  StarRatingComponent,
  UniversBesoinTableComponent,
  UniversBesoinQuestionTableComponent,
  UniversBesoinIconComponent,
  ProductRightIndicatorComponent,
  SimpleDocumentationComponent,
  RenewalAlertComponent,
  ImmatriculationComponent,
  PaymentOrderAlertComponent,
  SignatureOrderAlertComponent,
  CountdownComponent,
];

export const wzUiExportedPipes = [
  ToFixedPipe,
  ErrorPipe,
  FullNamePipe,
  AddressPipe,
  DateTimePipe,
  DatePipe,
  RequestColorPipe,
  UniversBesoinMetricPipe,
];
export const wzUiExportedDirectives = [
  ShowTransitionDirective,
  TunnelSanteTranslateDirective,
  SetFocusDirective,
  AsyncContentErrorDirective,
  ...EXPANDABLE_DIRECTIVES,
];

export const wzUiExportedEntry = [HealthHelpDialogComponent];
